<template>
  <div class="newPin">
    <div class="newPin__intro u-ta-center">
      <button
        id="dcNew"
        class="btn btn--primary"
        @click="openForm()"
        v-show="!newPinOpen"
      >
        Přidat pin do mapy ...
      </button>
    </div>

    <div
      v-bind:class="[
        'newPin__step',
        {
          'newPin__step--done': general.pin.phase > 1
        }
      ]"
      v-show="newPinOpen && general.pin.phase >= 1"
    >
      <span v-if="general.pin.phase > 1" style="margin-right: 10px;"
        ><i class="fas fa-check-circle"></i></span
      >1. Umístěte pin do mapy
    </div>
    <div
      class="newPin__step"
      v-show="(newPinOpen && general.pin.phase == 2) || general.pin.phase == 3"
    >
      2. Vyplňte formulář
      <br />

      <div
        v-for="(line, index) in Object.values(lines)"
        :key="line.id"
        class="drawingManager__Btn btnStyled btnWrapper"
      >
        <div class="verticalCenter">
          <i v-if="isDrawingMode && line.id === currentLine.id"
            >Délka: {{ currentLineLength }}m</i
          >
          <strong v-else>Oblast {{ index + 1 }} </strong>
        </div>

        <button
          @click="finishLine()"
          class="sideButton support"
          v-if="isDrawingMode && line.id === currentLine.id"
        >
          <i class="fas fa-check"></i> Dokončit
        </button>
        <button @click="editLine(line.id)" class="sideButton" v-else>
          <i class="fas fa-edit"></i> Upravit
        </button>
        <button @click="deleteLine(line.id)" class="sideButton">
          <i class="far fa-trash-alt"></i> Smazat
        </button>
      </div>

      <button
        @click="startLine()"
        class="drawingManager__Btn btnStyled edit"
        v-show="!isDrawingMode"
      >
        <i class="fas fa-plus-circle"></i> Zakreslit oblast zájmu
      </button>

      <div
        v-show="
          isDrawingMode &&
          lines[currentLine.id] === undefined &&
          currentLine.getPath().length === 0
        "
        class="drawingManager__Btn btnStyled btnWrapper"
      >
        <div class="verticalCenter">
          <i>Kliknutím do mapy začnete kreslit</i>
        </div>

        <button @click="cancelLine()" class="sideButton">
          Zrušit
        </button>
      </div>

      <div
        v-show="
          isDrawingMode &&
          lines[currentLine.id] === undefined &&
          currentLine.getPath().length > 0
        "
        class="drawingManager__Btn btnStyled btnWrapper"
      >
        <div class="verticalCenter">
          <i>Délka: {{ currentLineLength }}m</i>
        </div>

        <button @click="finishLine()" class="sideButton support">
          <i class="fas fa-check"></i> Ukončit kreslení a uložit
        </button>

        <button @click="cancelLine()" class="sideButton">
          Zrušit
        </button>
      </div>

      <form
        @submit="sendForm"
        method="post"
        class="form-horizontal"
        id="frm-drawingPinForm"
      >
        <input
          type="hidden"
          name="lat"
          id="dcLat"
          value=""
          v-model="general.pin.lat"
        />
        <input
          type="hidden"
          name="lng"
          id="dcLng"
          value=""
          v-model="general.pin.lng"
        />
        <input
          type="hidden"
          name="polylinePosition"
          id="dcPolylinePosition"
          value=""
          v-model="general.pin.polyline.position"
        />
        <br />
        <div class="form-control">
          <label for="frm-drawingPinForm-text">Název pinu</label>
          <input
            type="text"
            name="name"
            class="form-control"
            id="frm-drawingPinForm-name"
            v-model="pinName"
            required
          />
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-text">Popis pinu</label>
          <textarea
            name="description"
            class="form-control"
            id="frm-drawingPinForm-description"
            v-model="pinDescription"
            required
          ></textarea>
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-detail">Detail pinu</label>
          <textarea
            name="detail"
            class="form-control"
            id="frm-drawingPinForm-detail"
            v-model="pinDetail"
            required
          ></textarea>
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-picture">Obrázek</label>
          <br />
          <input
            type="file"
            name="picture"
            class="form-control"
            id="frm-drawingPinForm-picture"
            @change="picture = $event.target.files"
            accept="image/*"
          />
        </div>
        <div class="form-control">
          <label for="frm-drawingPinForm-attachments"
            >Přílohy ( maximálne 3 )</label
          >
          <br />
          <input
            type="file"
            name="attachments"
            class="form-control"
            id="frm-drawingPinForm-attachments"
            ref="attachments"
            @change="validateAttachments($event)"
            files
            multiple
          />
        </div>
        <br />
        <br />
        <WizardEventDispatcher :event="'click'" :target="'button-save-pin'">
          <input
            type="submit"
            class="btn btn-primary"
            value="Uložit nový pracovní pin ..."
          />
        </WizardEventDispatcher>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PinService from '@/services/PinService';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';

export default {
  components: {
    WizardEventDispatcher
  },
  data() {
    return {
      newPinOpen: true,
      newPinPhase: 0,
      pinName: '',
      pinDetail: '',
      pinDescription: '',
      attachments: null,
      picture: null
    };
  },
  created() {
    this.newPinPhase = this.general.pin.phase;
    this.$store.dispatch('general/setNewPinPhase', 1);
  },
  methods: {
    editLine(id) {
      if (!this.isDrawingMode) {
        this.$store.dispatch('general/startDrawingLine', { id });
      }
    },
    cancelLine() {
      this.$store.dispatch('general/cancelDrawingLine');
    },
    finishLine() {
      this.$store.dispatch('general/finishDrawingLine');
    },
    startLine() {
      this.$store.dispatch('general/startDrawingLine');
    },
    deleteLine(id) {
      if (!this.isDrawingMode) {
        this.$store.dispatch('general/deleteLine', { id });
      }
    },
    validateAttachments(event) {
      if (event && event.target.files.length > 3) {
        this.$refs.attachments.value = '';
      }

      this.attachments = event.target.files;
    },
    openForm() {
      this.newPinOpen = true;
      this.$store.dispatch('general/setNewPinPhase', 1);
    },
    closeForm() {
      this.newPinOpen = false;
      this.$store.dispatch('general/setNewPinPhase', null);
    },
    sendForm(e) {
      e.preventDefault();
      const lines = this.general.pin.lines;
      const linePaths = Object.values(lines).reduce((acc, line, index) => {
        acc[index] = line
          .getPath()
          .getArray()
          .map((l) => ({
            lat: l.lat(),
            lng: l.lng()
          }));
        return acc;
      }, {});

      const data = {
        lat: this.general.pin.lat,
        lng: this.general.pin.lng,
        title: this.pinName,
        text: this.pinDescription,
        text_detail: this.pinDetail,
        line: linePaths
      };

      const gmaps = this.gmaps;

      PinService.addPin(this.general.pin.layerId, data)
        .then((response) => {
          this.$store.dispatch('general/setNewPinPhase', null);
          this.$store.dispatch('general/setLayoutOption', ['newPin', false]);

          if (this.attachments) {
            this.attachments.forEach((file) => {
              const attachments = new FormData();

              attachments.append('file', file);

              PinService.addAttachments(
                response.data.data.id,
                response.data.data.drawingId,
                attachments
              ).catch(() => {});
            });
          }

          if (this.picture) {
            const image = new FormData();

            image.append('file', this.picture[0]);

            PinService.addPhoto(
              response.data.data.id,
              response.data.data.drawingId,
              image
            ).catch(() => {});
          }

          //debugger;

          this.$store.dispatch('threads/addNewPin', response.data.data);
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapState(['general', 'threads', 'gmaps']),
    isDrawingMode() {
      return !!this.general.pin.activeLine;
    },
    currentLine() {
      return this.general.pin.activeLine;
    },
    currentLineLength() {
      if (this.currentLine) {
        const path = this.currentLine.getPath();

        if (path.length > 1) {
          return parseFloat(
            this.gmaps.google.maps.geometry.spherical.computeLength(path)
          ).toFixed(1);
        }

        return 0;
      }
      return 0;
    },
    lines() {
      return this.general.pin.lines;
    }
  }
};
</script>
<style scoped>
input[name='name'] {
  padding: 10px;
  width: 100%;
}

.drawingManager__Btn {
  margin-top: 10px;
  background: whitesmoke;
  padding: 15px;
  box-shadow: 0 0.3rem 0.6rem rgba(0, 4, 8, 0.25);
  width: 100%;
  text-align: left;
  font-size: 12px;
}
.newPin__step--done {
  color: #84c03f;
  text-decoration: line-through;
}
</style>
<style>
.btnWrapper {
  display: flex;
  justify-content: space-between;
}

.btnWrapper .sideButton {
  font-size: 12px;
  background: none;
  border: none;
}

.btnWrapper .sideButton:hover {
  background: #eaf0f1;
}
.verticalCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
